import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import professionCases from 'helpers/professionCases';

const Responsibilities = styled('section')(({ theme }) => ({
  borderRadius: 15,
  border: `2px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.white.main,
  marginBottom: 25,
  paddingBottom: 15
}));

const Title = styled(Typography)(({ theme }) => ({
  padding: '11px 25px 10px',
  fontSize: 24,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left'
  }
}));

const Text = styled(Typography)(({ theme }) => ({
  padding: '16px 105px',
  borderTop: `1px solid ${theme.palette.textDisabled.main}`,
  '& span': {
    display: 'block',
    marginBottom: 15
  },
  fontSize: 16,
  [theme.breakpoints.down('md')]: {
    padding: '16px 50px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px 25px'
  }
}));

const ResponsibilitiesComponent = ({ professionInfo, t }) => {
  return (
    <Responsibilities>
      <Title variant={'h2'}>{t('WhoIs', professionCases(professionInfo, 'nominative'))}</Title>

      <Text variant="body1">
        {(professionInfo?.descriptionFull || '').split('\n\n').map((paragraph, index) => (
          <span key={index}>{paragraph}</span>
        ))}
      </Text>
    </Responsibilities>
  );
};

export default ResponsibilitiesComponent;
